exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sectionListComponent---1aYRe{margin:0 20px 20px;font-family:poppins}.root---37G_5{width:100%;overflow-x:auto}.table---8_Dfm{min-width:700px;font-family:poppins}", ""]);

// exports
exports.locals = {
	"sectionListComponent": "sectionListComponent---1aYRe",
	"root": "root---37G_5",
	"table": "table---8_Dfm"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/section-list/index.scss
// module id = 762
// module chunks = 3